<div class="ficha-cadastro-detalhe-cliente-caminhao-proprio-tempo">
  <form [formGroup]="form">
    <div class="form-group pb0">
      <span class="icon pesado"></span>
      <div class="inputs">
        <ng-container *ngIf="!isErroConsulta">
          <label>Placa: {{veiculoPlaca}}</label>
          <label>{{ descricaoVeiculo }}</label>
        </ng-container>
        <span
          *ngIf="isErroConsulta"
          class="ficha-cadastro-detalhe-cliente-caminhao-proprio-tempo_error">
          Não foi possível consultar a placa deste caminhão. Por isso, preencha abaixo os dados do veículo:
        </span>
      </div>
    </div>

    <div class="form-group pb0" [ngClass]="{'dn': !isErroConsulta}">
      <span class="icon"></span>
      <div class="inputs">
        <label for="categoria-veiculo">Categoria</label>
        <select
          formControlName="veiculoCategoria"
          appShowErrorMessages
          [hidden]="!isLoadingTipoVeiculo"
          requiredMessage="O Campo Categoria é obrigatório"
          class="form-control"
          name="categoria-veiculo">
          <option value="" selected hidden>Selecione...</option>
          <option *ngFor="let tv of listaTipoVeiculo" value="{{ tv.id }}">{{ tv.descricao }}</option>
        </select>
        <span *ngIf="isLoadingTipoVeiculo">
          <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
      </div>
    </div>

    <div class="form-group pb0" [ngClass]="{'dn': !isErroConsulta}">
      <span class="icon"></span>
      <div class="inputs">
        <label for="marca-veiculo">Marca do Veículo</label>
        <select
          formControlName="veiculoMarca"
          name="marca-veiculo"
          appShowErrorMessages
          [hidden]="!isLoadingMarca"
          class="form-control"
          requiredMessage="O Campo Marca do Veículo é obrigatório"
          (change)="onChangeMarca($event)"
          (blur)="onBlurMarca($event)">
          <option value="" selected hidden>Selecione...</option>
          <option *ngFor="let ma of listaMarca" [ngValue]="ma">{{ ma.descricao }}</option>
        </select>
        <div class="text-danger" *ngIf="!isSelectedMarcaAfterBlur && !isLoadingMarca">Marca do Veículo é obrigatória</div>
        <span *ngIf="isLoadingMarca">
          <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
      </div>
    </div>

    <div class="form-group pb0" [ngClass]="{'dn': !isErroConsulta}">
      <span class="icon"></span>
      <div class="inputs">
        <label for="ano-veiculo">Ano do Veículo</label>
        <select
          formControlName="veiculoAno"
          name="ano-veiculo"
          [hidden]="!isLoadingAnoModelo"
          requiredMessage="O Campo Ano do Veículo é obrigatório"
          id="vehicle-model-year"
          class="form-control"
          (change)="onChangeAnoModelo($event)"
          appShowErrorMessages
          (blur)="onBlurAnoModelo($event)">
          <option value="" selected hidden>Selecione...</option>
          <option *ngFor="let am of listaAnoModelo" value="{{ am.anoModelo }}">{{ am.anoModelo }}</option>
        </select>
        <div class="text-danger" *ngIf="!isSelectedAnoModeloAfterBlur">Ano Modelo do Veículo é obrigatório</div>
        <span *ngIf="isLoadingAnoModelo">
          <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
      </div>
    </div>

    <div class="form-group pb0" [ngClass]="{'dn': !isErroConsulta}">
      <span class="icon"></span>
      <div class="inputs">
        <label for="modelo-veiculo">Modelo do Veículo</label>
        <select
          formControlName="veiculoModelo"
          name="modelo-veiculo"
          [hidden]="!isLoadingModelo"
          id="vehicle-model"
          requiredMessage="O Campo Modelo do Veículo é obrigatório"
          class="form-control"
          appShowErrorMessages
          (change)="onChangeModelo($event)"
          (blur)="onBlurModelo($event)">
          <option value="" selected hidden>Selecione...</option>
          <option *ngFor="let mo of listaModelo" [ngValue]="mo">{{ mo.descricao }}</option>
        </select>
        <div class="text-danger" *ngIf="!isSelectedModeloAfterBlur">Modelo do Veículo é obrigatório</div>
        <span *ngIf="isLoadingModelo">
          <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
      </div>
    </div>

    <div class="form-group pb0" [ngClass]="{'dn': !isErroConsulta}">
      <span class="icon"></span>
      <div class="inputs">
        <label for="versao-veiculo">Versão do Veículo</label>
        <select
          formControlName="veiculoVersao"
          name="versao-veiculo"
          id="vehicle-version"
          class="form-control"
          appShowErrorMessages
          requiredMessage="O Campo Versão do Veículo é obrigatório"
          (change)="onChangeVersao($event)"
          (blur)="onBlurVersao($event)">
          <option value="" selected hidden>Selecione...</option>
          <option *ngFor="let ve of listaVersao" [ngValue]="ve">{{ ve.descricao }}</option>
        </select>
        <div class="text-danger" *ngIf="!isSelectedVersaoAfterBlur">Versão do Veículo é obrigatória</div>
        <span *ngIf="isLoadingVersao">
          <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
      </div>
    </div>

    <div class="form-group pb0">
      <span class="icon"></span>
      <div class="inputs">
        <label for="tempo-caminhao">Tempo que possuí o Caminhão Próprio</label>
        <select
          formControlName="tempoCaminhao"
          appShowErrorMessages
          class="form-control"
          name="tempo-caminhao">
          <option value="" selected hidden>Selecione...</option>
          <option *ngFor="let tv of temposCaminhao" value="{{ tv.valorNumerico }}">{{ tv.descricao }}</option>
        </select>
        <div class="text-danger" *ngIf="form.get('tempoCaminhao')?.hasError('required')">O tempo que possuí o caminhão é obrigatório</div>
      </div>
    </div>
  </form>
</div>

<app-modal-message #modalMessage [title]="'Atenção!'"></app-modal-message>
